import script from "./VitaBeruDetailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaBeruDetailModal.vue?vue&type=script&setup=true&lang=ts"

import "./VitaBeruDetailModal.vue?vue&type=style&index=0&id=07857560&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07857560"]])

export default __exports__